<app-alert-box-component
  (OnButtonClick)="onAlertButtonClick($event)"
  (OnAlertClose)="closeAlert($event)"
  (OnAlertVisibility)="alertVisibility($event)"
  [bShowSecondButton]="bShowSecondAlertButton"
  [alertHeaderText]="alertHeaderText"
  [alertBodyText]="alertBodyText"
  [closeButtonText]="alertCloseButtonText"
  [secondButtonText]="alertSecondButtonText"
  [data]="alertBoxData"
  [bAlert]="bAlert"></app-alert-box-component>

<div *ngIf="true">
  <c-navbar expand="lg" class="border-bottom border-bottom-3 border-bottom-primary">
    <c-container fluid>
      <form cForm class="row" [formGroup]="searchForm" (ngSubmit)="loadLeads()">
        <c-row [gutter]="{gy: 1}">
          <c-col lg="5">
            <c-date-range-picker
              [startDate]="startDate"
              [endDate]="endDate"
              (startDateChange)="onStartDateChane($event)"
              (endDateChange)="onEndDateChane($event)"></c-date-range-picker>
          </c-col>
          <c-col md="auto">
            <c-input-group class="has-validation">
              <span cInputGroupText>
                Status
              </span>
              <select cSelect id="leadStatusFilter" name="leadStatusFilter" formControlName="status">
                <option *ngFor="let status of statusOptions" [value]="status">{{status}}</option>
              </select>
            </c-input-group>
          </c-col>
          <c-col md="auto">
            <button cButton type="submit">
              Search
            </button>
          </c-col>
        </c-row>
      </form>
    </c-container>
  </c-navbar>

  <c-smart-table
    *ngIf="!showLeadDetails"
    [columnSorter]="true"
    [columns]="columns"
    [columnFilter]="true"
    [itemsPerPageSelect]="true"
    [itemsPerPage]="15"
    [items]="leadsData"
    [tableBodyProps]="{ align: 'middle' }"
    [tableProps]="{ hover: true, striped: true, responsive: true }"
    clickableRows
    header
    pagination
    (rowClick)="onRowClick($event)">
    <ng-template cTemplateId="tableData" let-columnName="columnName" let-item="item" let-tdContent="tdContent">
      <td>
        <ng-container [ngSwitch]="columnName">
          <ng-container *ngSwitchCase="'createdOn'">
            {{(getDisplayDate(item))}}
          </ng-container>
          <ng-container *ngSwitchCase="'leadStatus'">
            <c-badge [color]="getLeadStatusBadge(item.leadStatus)">
              {{item.leadStatus}}
            </c-badge>
          </ng-container>
          <ng-container *ngSwitchDefault>
            {{tdContent}}
          </ng-container>
        </ng-container>
      </td>
    </ng-template>
  </c-smart-table>

  <div *ngIf="showLeadDetails" class="lead-details">
    <div class="section-title">Prospective Customer Details</div>
    <form cForm [formGroup]="leadForm" class="needs-validation" [gutter]="3" novalidate>
      <div class="row">
        <div class="col-6">
          <label cLabel for="firstName">First Name</label>
          <input readonly cFormControl id="firstName" type="text" formControlName="firstName" />
        </div>
        <div class="col-6">
          <label cLabel for="lastName">Last Name</label>
          <input readonly cFormControl id="lastName" type="text" formControlName="lastName" />
        </div>
      </div>
      <div class="row pt-2">
        <div class="col-6">
          <label cLabel for="mobileNumber">Mobile</label>
          <input readonly cFormControl id="mobileNumber" type="text" formControlName="mobileNumber" />
        </div>
        <div class="col-6">
          <label cLabel for="email">Email</label>
          <input readonly cFormControl id="email" type="email" formControlName="email" />
        </div>
      </div>
      <div class="row pt-2">
        <div class="col-6">
          <label cLabel for="companyName">Company</label>
          <input readonly cFormControl id="companyName" type="text" formControlName="companyName" />
        </div>
        <div class="col-6">
          <label cLabel for="country">Country</label>
          <input readonly cFormControl id="country" type="text" formControlName="country" />
        </div>
      </div>
      <div class="row pt-2">
        <div class="col-6">
          <label cLabel for="leadSource">Source</label>
          <input readonly cFormControl id="leadSource" type="text" formControlName="leadSource" />
        </div>
        <div class="col-6">
          <label cLabel for="leadStatus">Status</label>
          <select cSelect id="leadStatus" name="leadStatus" formControlName="leadStatus">
            <option value="Open">Open</option>
            <option value="In Progress">In Progress</option>
            <option value="Approved">Approved</option>
            <option value="Rejected">Rejected</option>
          </select>
        </div>
      </div>
      <div class="row pt-2">
        <div class="col-12">
          <label cLabel for="message">Message</label>
          <textarea readonly cFormControl id="message" rows="4" formControlName="message"></textarea>
        </div>
      </div>
      <div class="row pt-2">
        <div class="col-12">
          <label cLabel for="remarks">Remarks</label>
          <textarea cFormControl id="remarks" rows="4" formControlName="remarks"></textarea>
        </div>
      </div>
      <div class="row" style="margin-top: 24px;">
        <div class="col-12 d-flex" style="justify-content: flex-end; gap: 16px;">
          <button cButton color="light" size="lg" type="button" (click)="backToList()">
            Back
          </button>
          <button cButton color="primary" size="lg" type="button" [disabled]="!canUpdateLead()" (click)="updateLead()">
            Update
          </button>
        </div>
      </div>
    </form>
  </div>
</div>
